import { useEffect, useState } from 'react';
import { useGetApiV1ExamDisciplineDropdownFiltered } from '@/shared/api/generated';
import { unwrapPagedResponse } from '@/shared/utils/unwrapPagedResponse';

/**
 * Hook para listar disciplinas ativas para uso em componentes de seleção.
 *
 * @param filter - Texto para busca server-side (mínimo 3 caracteres, debounce de 1 segundo)
 * @returns Lista de disciplinas com estado de loading
 *
 * @example
 * ```tsx
 * const { disciplines, isLoading } = useDisciplineDropdown(disciplineSearch);
 * ```
 */
export function useDisciplineDropdown(filter = '') {
  const [debouncedFilter, setDebouncedFilter] = useState('');

  useEffect(() => {
    if (filter === '') {
      setDebouncedFilter('');
      return;
    }
    const timer = setTimeout(() => setDebouncedFilter(filter), 1000);
    return () => clearTimeout(timer);
  }, [filter]);

  const isReady = debouncedFilter.length >= 3;
  const { data, isLoading, isSuccess } = useGetApiV1ExamDisciplineDropdownFiltered(
    isReady ? { filter: debouncedFilter } : undefined,
    { query: { enabled: isReady } },
  );
  return { disciplines: unwrapPagedResponse(data), isLoading, isQuerySuccess: isSuccess } as const;
}
